import Swiper from "swiper/swiper-bundle.esm";
function handleSwiper(swiper) {
  var TYPE_CONTROL =
      swiper.slides[swiper.activeIndex].classList.contains("has-video");
  var autoplayDelay = swiper.params.autoplay.delay / 1000;
  var VIDEO = swiper.slides[swiper.activeIndex].firstElementChild;

  // console.log("swiper.slides[swiper.activeIndex]", swiper.slides[
  //   swiper.activeIndex
  // ].firstElementChild)


  /* get Current Time */
  // function getCurrentTime() {
  if (TYPE_CONTROL) {
    var getCurrentTime = function () {
      var endTime = VIDEO.duration.toFixed();
      var currentTime = VIDEO.currentTime.toFixed();
      // console.log("endTime:", endTime)
      // console.log("currentTime:", currentTime)

      if (currentTime == endTime - autoplayDelay) {
        swiper.autoplay.start();
      }
    }
  }
  /* end get Current Time */
  /* ------- TYPE_CONTROL -------- */
  if (TYPE_CONTROL) {
    /* AUTO_PLAY OFF */
    swiper.autoplay.stop();
    // console.log("TYPE_CONTROL:", TYPE_CONTROL);

    swiper.slides[
        swiper.activeIndex
        ].firstElementChild.nextElementSibling.nextElementSibling.style.display =
        "flex";

    swiper.slides[
        swiper.activeIndex
        ].firstElementChild.nextElementSibling.classList.add("pause-icon");
    swiper.slides[
        swiper.activeIndex
        ].firstElementChild.nextElementSibling.classList.remove("play-icon");

    swiper.slides[
        swiper.activeIndex
        ].firstElementChild.nextElementSibling.addEventListener(
        "click",
        PlayVideo,
        false
    );
    /* PlayVideo */
    function PlayVideo(e) {
      e.preventDefault();
      e.stopPropagation();

      if (swiper.slides[swiper.activeIndex].firstElementChild.paused) {
        this.classList.add("play-icon");
        this.classList.remove("pause-icon");
        /*
        swiper.slides[
          swiper.activeIndex
        ].firstElementChild.nextElementSibling.nextElementSibling.style.display =
          "none";
          */
      } else {
        this.classList.add("pause-icon");
        this.classList.remove("play-icon");
        /*
        swiper.slides[
          swiper.activeIndex
        ].firstElementChild.nextElementSibling.nextElementSibling.style.display =
          "flex";
          */
      }
    }
    /* end PlayVideo */
    /* VIDEO MUTED ON OFF */
    let mutedBTN =
        swiper.slides[swiper.activeIndex].firstElementChild
            .nextElementSibling.nextElementSibling;

    mutedBTN.addEventListener("click", mutedOnOff, false);
    /* mutedOnOff */
    function mutedOnOff(e) {
      e.preventDefault();
      e.stopPropagation();

      mutedBTN.classList.remove("mute-btn--toggled");

      if (swiper.slides[swiper.activeIndex].firstElementChild.muted) {
        mutedBTN.classList.add("mute-btn--toggled");
      } else {
        mutedBTN.classList.remove("mute-btn--toggled");
      }
    }
    /* end mutedOnOff */
    /* --------------- */
    if (swiper.slides[swiper.activeIndex].firstElementChild.muted) {
      mutedBTN.classList.add("mute-btn--toggled");
    } else {
      mutedBTN.classList.remove("mute-btn--toggled");
    }
    /* --------------- */

    VIDEO.ontimeupdate = function () {
      getCurrentTime();
    };


    /* --------------- */
    for (var i = 0; i < swiper.slides.length; i++) {
      var video = swiper.slides[i].querySelector("video");
      var activeVideo = swiper.slides[swiper.activeIndex].querySelector("video");
      if (swiper.slides[i].classList.contains("has-video")) {
        video.muted = true;
        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.then(_ => {
            console.log("Automatic playback started! ")
          })
              .catch(error => {
                console.log("error -> ", error)
              });
        }
        console.log("...")
      }
    }
  } else {
    /* AUTO_PLAY ON */
    swiper.autoplay.start();

    for (var i = 0; i < swiper.slides.length; i++) {
      var video = swiper.slides[i].querySelector("video");
      var TYPE_CONTROL =
          swiper.slides[swiper.activeIndex].classList.contains("has-video");
      if (swiper.slides[i].classList.contains("has-video")) {
        // video.pause();
        var playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.then(_ => {
            if (TYPE_CONTROL) {
              console.log("We can now safely pause video...")
              video.pause();
            }
          })
              .catch(error => {
                console.log("error -> ", error)
              });
        }
        video.muted = true;
      }
    }
  }
  /* ------- TYPE_CONTROL -------- */
}
export function getPromoSwiper() {
  // console.log("getPromoSwiper");
  const swiper = new Swiper("#promoSwiper", {
    loop: true,
    // cssMode: true,
    // effect: 'fade',
    autoplay: {
      delay: 6000,
    },
    keyboard: true,

    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    pagination: {
      el: ".swiper-pagination",
    },
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      loadPrevNext: true,
    },
    on: {
      afterInit: function (swiper) {
        console.log("getPromoSwiper - afterInit", swiper.activeIndex);
        handleSwiper(swiper);
      },
      slideChange: function (swiper) {
        console.log("getPromoSwiper - slideChange", swiper.activeIndex);
        handleSwiper(swiper);
      },
    },
  });
}
/* global page */
function globalPageSwiper() {
  let globalPageSwiper = document.getElementsByClassName("globalPageSwiper");
  if (globalPageSwiper) {
    var swiper = new Swiper(".globalPageSwiper", {
      pagination: {
        el: ".swiper-pagination",
      },
      lazy: {
        loadPrevNext: true,
      },
      preloadImages: false,
    });
  }
}
export { globalPageSwiper };
/* homeproductSwiper */
function homeproductSwiper() {
  let homeproductSwiper = document.getElementsByClassName("homeproductSwiper");
  if (homeproductSwiper) {
    var swiper = new Swiper(".homeproductSwiper", {
      loop: false,
      rewind: true,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      lazy: {
        loadPrevNext: true,
      },
      preloadImages: false,
      on: {
        init: function (swiper) {
          let whoSwipper = document.querySelector(".homeproduct-section");
          let index_currentSlide = swiper.realIndex;
          let currentSlide = swiper.slides[index_currentSlide];
          whoSwipper.style.backgroundColor = currentSlide.dataset.bg;
        },
        slideChange: function (swiper) {
          let whoSwipper = document.querySelector(".homeproduct-section");
          let index_currentSlide = swiper.realIndex;
          let currentSlide = swiper.slides[index_currentSlide];
          whoSwipper.style.backgroundColor = currentSlide.dataset.bg;
        },
      },
    });
  }
}
export { homeproductSwiper };

/* Thumbs Slider */
function thumbnailPageSwiper() {
  let thumbsSwiper = document.getElementsByClassName("thumbsSwiper");
  let thumbsSwiperMini = document.getElementsByClassName("thumbsSwiperMini");
  if (thumbsSwiper && thumbsSwiperMini) {
    var swiper = new Swiper(".thumbsSwiperMini", {
      spaceBetween: 0,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".thumbsSwiper", {
      zoom: true,
      spaceBetween: 0,
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true,
      // },
      thumbs: {
        swiper: swiper,
      },
    });
    // var swiper = new Swiper(".thumbsSwiper", {
    //   pagination: {
    //     el: ".swiper-pagination",
    //   },
    //   lazy: {
    //     loadPrevNext: true,
    //   },
    //   preloadImages: false,
    // });
    var thumbsSwiperSlide = document.querySelectorAll('.thumbsSwiper .swiper-slide');

    for (var index = 0; index < thumbsSwiperSlide.length; index++) {
      thumbsSwiperSlide[index].addEventListener('click', function (e) {
        if (swiper2.zoom.scale === 1) {
          swiper2.zoom.in();
          console.log("zoom in");
        } else {
          swiper2.zoom.out();
          console.log("zoom out");
        }
      });
    }
    /*
    for (var index = 0; index < swiperSlide.length; index++) {
      swiperSlide[index].addEventListener('mouseover', function (e) {
        swiper2.zoom.in();
        console.log("in")
      })

      swiperSlide[index].addEventListener('mouseout', function (e) {
        swiper2.zoom.out();
        console.log("out")
      })
    }
    */
  }
}
export { thumbnailPageSwiper };
/* project page */
function projectPageSwiper() {
  let projectPageSwiper = document.getElementsByClassName("projectPageSwiper");
  if (projectPageSwiper) {
    var swiper = new Swiper(".projectPageSwiper", {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      centeredSlides: true,
      hashNavigation: {
        watchState: true,
      },
      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true,
      // },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        772: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      on: {
        slideChange: function (swiper) {
          setTimeout(() => {
            let hash = window.location.hash;
            hash = hash.replace("#", "");

            let defaultProjectItem = document.querySelector(
                ".lightboxWrapper__inner:first-child"
            );
            let projectItem = document.querySelector(`[data-id="${hash}"]`);
            let allProjectItem = document.querySelectorAll(
                ".lightboxWrapper__inner"
            );
            // console.log("allProjectItem", allProjectItem);
            allProjectItem.forEach((e) => (e.style.display = "none"));

            if (hash) {
              projectItem.style.display = "block";
            } else {
              defaultProjectItem.style.display = "block";
            }
          }, 500);
        },
      },
    });
  }
}
export { projectPageSwiper };
